import $cookies from '@/plugins/vueCookies'

export const referreCodeName = 'bn_referral_code'

export default async (to, from, next) => {
  const utmPrefix = 'utm_'
  const utmKeys = Object.keys(to.query).filter((k) => k.indexOf(utmPrefix) > -1)
  if (utmKeys.length > 0) {
    const utm = {}
    for (const k of utmKeys) {
      utm[k.replace(utmPrefix, '')] = to.query[k]
    }
    $cookies.set('bn_utm', JSON.stringify(utm), 0)
  }

  // URL에 referral_code가 있으면 쿠키에 저장
  if (to.query.referral_code) {
    $cookies.set(referreCodeName, to.query.referral_code, 0) // 'bn_referral_code'로 쿠키에 저장
  }

  next()
}
